var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressBarRebrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 49,
    viewBox: "0 0 54 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7573 1.84057C46.851 6.91125 53.5705 15.8724 51.599 26.5556C49.7324 36.6709 40.9308 43.3049 32.4682 45.8804C25.1281 48.1143 14.22 46.479 9.24 38.8885C8.00403 37.0047 6.78121 31.9733 8.38701 27.7011C10.9144 20.977 20.4384 22.6493 19.6718 27.9679C18.9052 33.2866 11.781 37.5687 6.73725 33.2229C-3.21796 24.6451 4.14155 13.8748 5.40672 11.8875C7.95782 7.88036 11.7884 4.32148 15.8584 2.0317",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBarRebrand);
export default __webpack_public_path__ + "static/media/progress-bar-rebrand.3385bdd087968e2ad40c4bfccac2516e.svg";
export { ForwardRef as ReactComponent };